import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import _ from "lodash";

import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { environment } from "../../../../../environments/environment";
import { HelperService } from "@services/helper.service";

@Injectable({
	providedIn: "root",
})
export class TestToolService {
	private apiURL = environment.apiBaseUrl;

	httpOptions = {
		headers: new HttpHeaders({
			"Content-Type": "application/json",
		}),
	};

	constructor(
		private httpClient: HttpClient,
		private helperService: HelperService
	) {}

	get(id, params = {}): Observable<any> {
		return this.httpClient
			.get(`${this.apiURL}/tools/${id}`, { params: params })
			.pipe(catchError(this.helperService.errorHandler.bind(this)));
	}

	getListing(params) {
		let tableParams = _.cloneDeep(
			this.helperService.convertToTableListingParams(params)
		);

		let requestParams: any = {
			...tableParams,
		};
		let requestParamsString = this.helperService.convertQueryParams(
			requestParams,
			""
		);

		return this.httpClient
			.get(`${this.apiURL}/tools?${requestParamsString}`)
			.pipe(catchError(this.helperService.errorHandler.bind(this)));
	}

	createNewTestTool(params) {
		let requestParams = {};

		return this.httpClient
			.post(this.apiURL + "/tools", params)
			.pipe(catchError(this.helperService.errorHandler.bind(this)));
	}

	update(id, formData: any) {
		return this.httpClient
			.put(this.apiURL + `/tools/${id}`, formData)
			.pipe(catchError(this.helperService.errorHandler.bind(this)));
	}

	deleteTools({ tool_ids }) {
		let params: any = {
			body: {
				ids: tool_ids,
			},
		};

		return this.httpClient
			.delete(`${this.apiURL}/tools/mass-delete`, params)
			.pipe(catchError(this.helperService.errorHandler.bind(this)));
	}

	changeStatus({ tool_ids, status_reason }) {
		let params = {
			status_reason: status_reason,
			ids: tool_ids,
		};

		return this.httpClient
			.post(`${this.apiURL}/tools/update-status`, params)
			.pipe(catchError(this.helperService.errorHandler.bind(this)));
	}

	storeFirstLog({ tool_ids, location_id }) {
		let params = {
			tool_ids: tool_ids,
			location_id: location_id,
		};

		return this.httpClient
			.post(`${this.apiURL}/service-tool-logs`, params)
			.pipe(catchError(this.helperService.errorHandler.bind(this)));
	}

	checkRevertLocationPermission() {
		let params = {};

		return this.httpClient
			.get(
				`${this.apiURL}/storage-locations/check-revert-location-permission`,
				params
			)
			.pipe(catchError(this.helperService.errorHandler.bind(this)));
	}

	revertLocation(params: any) {
		// return this.httpClient.post(`${this.apiURL}/tools/update-status`, params).pipe(
		// 	catchError(this.helperService.errorHandler.bind(this))
		// )

		return this.httpClient
			.post(
				`${this.apiURL}/storage-locations/revert-back-to-location`,
				params
			)
			.pipe(catchError(this.helperService.errorHandler.bind(this)));
	}
}
